import localFont from "next/font/local";
// const font = localFont({
// 	variable: "--main-font",
// 	display: "swap",
// 	// preload: true,
// 	preload: true,
// 	src: [
// 		{
// 			path: "../assets/fonts/IRANYekanX/woff2/IRANYekanX-Regular.woff2",
// 			weight: "400",
// 			style: "normal",
// 		},
// 	],
// });

const font = localFont({
	variable: "--main-font",
	display: "fallback",
	preload: true,
	src: [
		{
			path: "../assets/fonts/IRANYekanX/IRANYekanXVF.woff2",
			weight: "100 1000",
			style: "normal",
		},
	],
});

export default font;
